import React, { useEffect, useState } from "react";

export const Tabs = ({contenidos}) => {
    const nombresMenus = contenidos.map((data,i) => (data.nombreMenu || `Menu ${i+1}`))
    const menusContenidos = contenidos.map(data => data.contenidoMenu)

    const [menuSeleccionado,setMenuSeleccionado] = useState(0)

    return (
        <>
            <div className="flex flex-col w-full h-full">
                <div className="flex">
                    {
                        nombresMenus.map((data,i) => {
                            return(
                                <div 
                                    key={i+1}
                                    onClick={() => setMenuSeleccionado(i)} 
                                    className={`${menuSeleccionado == i ? 'border-x border-t cursor-default' : 'hover:bg-gray-600 cursor-pointer'} w-[150px] text-center p-2 flex items-center justify-center rounded-t-md`}
                                >
                                    {data}
                                </div>
                            )
                        })
                    }
                </div>
                <div className="border-t p-2">
                    {menusContenidos.length != 0 ? menusContenidos[menuSeleccionado] : 'No hay contenido'}
                </div>
            </div>
        </>
    )
};